'use client';

import { useState, useEffect } from 'react';
import "../../../styles/Home/Solutions/solutions.css";

export default function ZoomableImage({ src, alt }: { src: string; alt: string }) {
  const [isZoomed, setIsZoomed] = useState(false);
  const [closing, setClosing] = useState(false);

  const handleOpen = () => {
    setIsZoomed(true);
    setClosing(false);
    document.body.style.overflow = 'hidden';
  };

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setIsZoomed(false);
      setClosing(false);
      document.body.style.overflow = '';
    }, 300);
  };

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isZoomed) {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isZoomed]);

  return (
    <>
      <img src={src} alt={alt} className="img-fluid zoomable-thumbnail" onClick={handleOpen} />

      {isZoomed && (
        <div className={`zoomable-overlay ${closing ? 'closing' : ''}`} onClick={handleClose}>
          <img
            src={src}
            alt={alt}
            className={`img-fluid zoomable-image ${closing ? 'closing' : ''}`}
            onClick={handleOpen}
          />
        </div>
      )}
    </>
  );
}
